import { Switch, Button, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { FieldList } from './constant';
import MenuSetting from '../../../../services/menuSetting';

const VisibleField = (props) => {
    const defaultSetting = {
        "restaurant_id": props.adminRestaurant,
        "apply_gratuity_on_party_greater_than": 1,
        "gratuity_amount": 1,
        "allow_dairy": false,
        "allow_nuts": false,
        "allow_vegetarian": false,
        "allow_description": false,
        "allow_calories": false,
        "allow_gluten_free": false,
        "allow_vegan": false
      };
    const [settingsList, setSettingsList ] = useState(defaultSetting);

    useEffect(()=>{
        MenuSetting.getRestaurentSettings(props.adminRestaurant).then((res)=>{
            if(res?.restaurant_id){
                setSettingsList(res);
            } else {
                setSettingsList(defaultSetting);
            }
        });
    }, [props.adminRestaurant]);

    const onUpdateSettings = (e, field) => {
        const curentSettings = {...settingsList};
        curentSettings[field] = e;
        setSettingsList(curentSettings);
    };
    const onSaveSettings = () => {
        const currentList = {... settingsList};
        delete currentList.created_at;
        delete currentList.id;
        delete currentList.updated_at;
        delete currentList.allow_spice_level;
        delete currentList.restaurant_id;
        currentList.est_prep_mins_for_delivery = currentList.est_prep_mins_for_delivery ?? 0;
        currentList.est_prep_mins_for_takeout = currentList.est_prep_mins_for_takeout ?? 0;
        MenuSetting.saveRestaurentSettings(currentList).then((res)=>{
            if(res){
                message.success('Successfully updated the changes');
            }

        });
    };
    return <div className="table_section field_wrap">
        <div className="field_title">Edit visible field of a food item</div>
        <div className='field_ctrllist'>
        {
            FieldList.map((item)=>{
                return <div className="ctrl_field">
                <span><Switch checked={settingsList[item.key]} onChange={(e)=>{onUpdateSettings(e, item.key)}}/></span>
                <label>{item.label}</label>
            </div>
            })
        }
        </div>
        <Button 
            type="primary" 
            className='field_save_btn' style={{ width:"180px", height: "45px", marginBottom: "10px" }} 
            onClick={onSaveSettings}
        >
            Save
        </Button>
    </div>
};
export default VisibleField;
